export const fetchRecover = async ({ login }: { login: string }) => {
	try {
		const formData = new FormData();

		formData.append('method', 'reset_password');
		formData.append('login', login.trim());

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		let data;
		const text = await response.text();
		try {
			data = JSON.parse(text);
		} catch {
			data = { error_text: text };
		}

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		return { error_text: 'Не удалось выполнить запрос' };
	}
};
